export default (state, getters, rootState, rootGetters) => val => {
    let selections = state.selections.indexOf(val);
    return state.selections.indexOf(val)>=0;
}
